module.exports = __webpack_public_path__ + "img/TMDB_logo_alt.56fd61ee.svg";